import { Button, Typography } from '@libs/components';

import { useTranslation } from 'src/hooks';

import { ContentContainer, DescriptionWrapper } from './styles';

type PnlInfoProps = {
  closeModal: () => void;
  text?: string;
};
const PnlInfo: React.FC<PnlInfoProps> = ({ closeModal, text }) => {
  const { t } = useTranslation();
  return (
    <ContentContainer>
      <DescriptionWrapper>
        <Typography type="subHeadline" fontFamily="primaryMedium">
          {text || t('wallet_selected_asset_market_info')}
        </Typography>
      </DescriptionWrapper>

      <Button
        size="lg"
        title={t('common_close')}
        onClick={closeModal}
        buttonType="secondary"
      />
    </ContentContainer>
  );
};

export default PnlInfo;
